export * from "../ploom/emoji-face-sad";
